import React, { useEffect, useState } from 'react';
import { Tree, Row, Col, Modal, Icon, Tooltip } from 'antd';
import { AntTreeNode } from 'antd/lib/tree';

import { isValidGuid } from '@app/helpers/geradorGuid';
import { dragInDropMinutaItemClausula, getByIdMinuta, postMinuta } from '@app/api/minuta/Minutas';
import MinutaCabecalho from '../compontents/MinutaCabecalho';
import MinutaContent from '../compontents/MinutaContent';

import { Button, GridView, useRouter } from '@digital/ui';
import { IEmCustomizacaoMinuta, IMinuta, IMinutaClausula } from '@app/models/MinutaModels';
import { getTipoClausulaNome } from '@app/enums/ETipoClausulaNomeById';

const { TreeNode } = Tree;
const { confirm } = Modal;

const MinutaCustomizacao = () => {
  const { history } = useRouter();

  const params = new URLSearchParams(location.search);
  const minutaIdParam = isValidGuid(params.get('id') || '') ? params.get('id') : null;

  const [minuta, setMinuta] = useState<IMinuta>({} as IMinuta);

  const [inputDescricao, setInputDescricao] = useState<string>('');

  //#region Consultas na API
  const initMinuta = async () => {
    if (minutaIdParam) {
      let minutaApi = (await getByIdMinuta(minutaIdParam)) || ({} as IMinuta);
      minutaApi.minutasPorTipoClausula.forEach(mtc => {
        mtc.minutaClausulas.sort((a, b) => a.ordenacao - b.ordenacao);
      });

      setMinuta(minutaApi);
      setInputDescricao(minutaApi.descricao || '');
    }
  };
  //#endregion

  useEffect(() => {
    initMinuta();
  }, []);

  useEffect(() => {
    initMinuta();
  }, [minutaIdParam]);

  const handlerOnChangeInputDescricao = (value: string) => {
    setInputDescricao(value);
  };

  const handlerClickSaveMinuta = async () => {
    if (inputDescricao.length == 0 || inputDescricao.replaceAll(' ', '').length == 0) {
      await confirm({
        title: 'A descrição nao pode ser vazia!',
        icon: <Icon type="info-circle" />,
        onOk: async () => {
          return;
        },
        onCancel() {
          return;
        },
      });
      return;
    }

    var data = {
      id: minuta.id,
      descricao: inputDescricao,
    } as IEmCustomizacaoMinuta;

    await postMinuta(data);
    history.push(`/minutas/preencherMinuta?id=${minutaIdParam}`);
  };

  const onDropTree = async (info: any) => {
    const dropKey = info.node.props.eventKey;
    const dragKey = info.dragNode.props.eventKey;
    const dropPos = info.node.props.pos.split('-');
    const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

    //Evitar mover para dentro das clasulas ou dos items
    if (dropPosition === 0) {
      return;
    }

    var minutaAPi = (await dragInDropMinutaItemClausula({
      minutaId: minuta.id,
      itemDrag: dragKey,
      itemDrop: dropKey,
      position: dropPosition,
    })) as IMinuta;

    setMinuta(minutaAPi);
  };

  const generateIdHash = (prefix: string, id: string) => prefix + '-' + id.substring(5, 12);

  //#region Renders
  const renderNodeTreeSider = (minutaClausulas: IMinutaClausula[]) => {
    return minutaClausulas.map((clausula: IMinutaClausula) => {
      return (
        <TreeNode title={clausula.descricao} key={clausula.id}>
          {clausula.itens &&
            clausula.itens.length > 0 &&
            clausula.itens.map(item => (
              <TreeNode title={item.descricao} key={item.id} hash={generateIdHash('h', item.id)} />
            ))}
        </TreeNode>
      );
    });
  };

  const renderTreeSider = () => {
    return (
      minuta.minutasPorTipoClausula &&
      minuta.minutasPorTipoClausula.length > 0 && (
        <Tree
          showLine={true}
          draggable
          blockNode
          onDrop={onDropTree}
          defaultExpandedKeys={[minuta.minutasPorTipoClausula && minuta.minutasPorTipoClausula[0].tipoClausulaId]}
          onClick={(e: React.MouseEvent<HTMLElement>, node: AntTreeNode) => {
            window.location.hash = "item" + (node.props.hash || node.props.eventKey || '');
          }}>
          {minuta.minutasPorTipoClausula.map(mptc => (
            <TreeNode title={getTipoClausulaNome(mptc.tipoClausulaId)} key={mptc.tipoClausulaId}>
              {mptc.minutaClausulas && renderNodeTreeSider(mptc.minutaClausulas)}
            </TreeNode>
          ))}
        </Tree>
      )
    );
  };

  const renderConteudoMinutaCustomizacao = () => (
    <Row
      style={{
        background: '#fff',
        padding: 8,
        margin: 0,
      }}>
      <Col
        span={6}
        style={{
          overflow: 'hidden',
        }}>
        <div>{renderTreeSider()}</div>
      </Col>
      <Col
        span={18}
        style={{
          padding: 16,
          margin: 0,
          borderLeft: '1px solid  #ccc',
        }}>
        {minuta.minutasPorTipoClausula && minuta.minutasPorTipoClausula.length > 0 && (
          <MinutaContent
            minutasPorTipoClausula={minuta.minutasPorTipoClausula || []}
            onExecuteAnAfterActionHandle={async () => {
              await initMinuta();
            }}
          />
        )}
        {/* <Button
          key="dalvar-customizacao"
          icon="ui-save"
          type="primary"
          style={{
            float: 'right',
            marginTop: 24,
          }}
          onClick={handlerClickSaveMinuta}>
          SALVAR
        </Button> */}
      </Col>
    </Row>
  );

  const renderActions = (): React.ReactNode[] =>
    [
      <Tooltip title="Salvar minuta">
        <Button
          key="salvar-customizacao"
          icon="ui-save"
          type="primary"
          onClick={handlerClickSaveMinuta}
        >
          SALVAR
        </Button>
      </Tooltip>
    ]

  //#endregion

  return (
    <GridView noform icon="ui-list" id="customizacaoDaMinuta" title="Customização Da Minuta">
      {minuta && (
        <MinutaCabecalho
          minuta={minuta}
          inputDescricao={{
            value: inputDescricao,
            onChange: handlerOnChangeInputDescricao,
          }}
          actions={renderActions()}
        />
      )}
      {renderConteudoMinutaCustomizacao()}
    </GridView>
  );
};

export default MinutaCustomizacao;
